module.exports = __webpack_public_path__ + "ed209af3220a7af8f38bc575402432d0.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/martin-kleppe.jpg
// module id = 671
// module chunks = 0